function escapeHtml(value) {
    return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
}

function alignmentMarker(alignment) {
    switch (alignment) {
        case 'center': return ':---:'
        case 'right': return '---:'
        default: return '---'
    }
}

export function toMarkdownTable(grid, {hasHeader = true, alignments = []} = {}) {
    if (!grid.length || !grid[0].length) return ''

    const columnCount = grid[0].length
    const renderRow = row => `| ${row.map(cell => (cell || '').trim() || ' ').join(' | ')} |`
    const rows = grid.map(renderRow)

    if (!hasHeader) return rows.join('\n')

    const [headerRow, ...bodyRows] = rows
    const separator = `| ${Array(columnCount).fill(0).map((_, i) => alignmentMarker(alignments[i])).join(' | ')} |`
    return [headerRow, separator, ...bodyRows].join('\n')
}

export function toHtmlTable(grid, {hasHeader = true} = {}) {
    if (!grid.length || !grid[0].length) return ''

    const renderRow = (row, tag) =>
        `  <tr>\n${row.map(cell => `    <${tag}>${escapeHtml(cell || '')}</${tag}>`).join('\n')}\n  </tr>`

    const headerPart = hasHeader ? `  <thead>\n${renderRow(grid[0], 'th')}\n  </thead>\n` : ''
    const bodyRows = hasHeader ? grid.slice(1) : grid
    const bodyPart = `  <tbody>\n${bodyRows.map(row => renderRow(row, 'td')).join('\n')}\n  </tbody>`

    return `<table>\n${headerPart}${bodyPart}\n</table>`
}

export function createEmptyGrid(rowCount, columnCount) {
    return Array.from({length: rowCount}, () => Array(columnCount).fill(''))
}
